import { createJSONRequest } from '../../../api/create-request.js'

export const fetchEcosystemMaps = () => {
  return createJSONRequest({
    method: 'GET',
    url: '/api/settings/ecosystem-maps',
  })
}

export const fetchEcosystemMap = (id: number) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/settings/ecosystem-maps/${id}`,
  })
}

export const createEcosystemMap = (mapData: object) => {
  return createJSONRequest({
    method: 'POST',
    url: '/api/settings/ecosystem-maps',
    data: mapData,
  })
}

export const updateEcosystemMap = (id: number, mapData: object) => {
  return createJSONRequest({
    method: 'PUT',
    url: `/api/settings/ecosystem-maps/${id}`,
    data: mapData,
  })
}

export const deleteEcosystemMap = (id: number) => {
  return createJSONRequest({
    method: 'DELETE',
    url: `/api/settings/ecosystem-maps/${id}`,
  })
}

export const updateEcosystemMapStatus = (id: number, status: string) => {
  return createJSONRequest({
    method: 'PUT',
    url: `/api/settings/ecosystem-maps/${id}/status`,
    data: { status },
  })
}

export const fetchEcosystemMapEmbedData = (id: number, apiKey: string) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/ecosystem-maps/${id}?key=${apiKey}`,
  })
}

export const trackEcosystemMapView = (id: number, apiKey: string) => {
  return createJSONRequest({
    method: 'POST',
    url: `/api/ecosystem-maps/${id}/track-view?key=${apiKey}`,
  })
}

export const fetchEcosystemMapVersions = (id: number) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/settings/ecosystem-maps/${id}/versions`,
  })
}

export const fetchEcosystemMapVersion = (id: number, versionId: number) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/settings/ecosystem-maps/${id}/versions/${versionId}`,
  })
}

export const restoreEcosystemMapVersion = (id: number, versionId: number) => {
  return createJSONRequest({
    method: 'POST',
    url: `/api/settings/ecosystem-maps/${id}/versions/${versionId}/restore`,
  })
}

export const updateEcosystemMapVersionLabel = (id: number, versionId: number, label: string) => {
  return createJSONRequest({
    method: 'PUT',
    url: `/api/settings/ecosystem-maps/${id}/versions/${versionId}/label`,
    data: { label },
  })
}

export const fetchCommunityEcosystemMaps = (communityId: number) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/communities/${communityId}/ecosystem-maps`,
  })
}

export const searchCities = (query: string, countryCode?: string) => {
  const params = new URLSearchParams({ query })
  if (countryCode) {
    params.append('country_code', countryCode)
  }
  return createJSONRequest({
    method: 'GET',
    url: `/api/settings/ecosystem-maps/search-cities?${params.toString()}`,
  })
}
